<template>
  <div class="view">
    <div class="py-2">
      <ProspectsColumn
        v-for="col of allColumns"
        :key="col.value"
        :title="col.text"
        :description="col.description"
        :prospects="
          col.value === 'all' ? all : groupByProgress[col.value] || []
        "
        @update="$emit('update')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { ALL_PROSPECTS_COLUMNS } from "@/data/DefaultSettings";
import ProspectsColumn from "./ProspectsColumn";

export default {
  name: "ProspectsView",
  components: { ProspectsColumn },
  props: ["column"],
  computed: {
    ...mapState("prospects", ["all"]),
    ...mapGetters("prospects", ["groupByProgress"]),
    allColumns() {
      return ALL_PROSPECTS_COLUMNS.filter(
        col =>
          (this.$mq !== "sm" && col.value !== "all") ||
          (this.$mq === "sm" && this.column === col.value)
      );
    }
  }
};
</script>

<style scoped>
.view {
  position: absolute;
  top: 160px;
  bottom: 10px;
  left: 0;
  right: 0;

  overflow: auto;
}

@media screen and (max-width: 450px) {
  .view {
    position: static;
  }
}

.view > div {
  display: flex;
}
</style>
